import React from "react";
import PropTypes from "prop-types";
import * as MaterialIcon from "@mdi/react";

const Icon = ({ symbol, size, color, ...rest }) => (
  <MaterialIcon.Icon
    path={symbol}
    size={size / 1.5}
    css={`
      fill: ${color};
    `}
    {...rest}
  />
);

Icon.propTypes = {
  symbol: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
};

Icon.defaultProps = {
  symbol: "",
  size: 1,
  color: "#8E8279"
};

export default Icon;
